import React from 'react';
import PropTypes from 'prop-types';

import {
    Tooltip,
    TooltipPopper,
} from '@zillow/constellation';

import {
    StyledTooltipText,
} from './StyledComponents';

const propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
    ]).isRequired,
};

function HeaderTooltip({ title, message }) {
    const tooltipContent = (
        <Tooltip body={(<StyledTooltipText fontType="finePrint" as="p">{message}</StyledTooltipText>)} />
    );

    return (
        <React.Fragment>
            {title}
            <TooltipPopper
                triggered={tooltipContent}
                placement="top"
                mouseLeaveDelay={1500}
            />
        </React.Fragment>
    );
}

HeaderTooltip.propTypes = propTypes;

export default HeaderTooltip;
